import React, { useEffect, useState, useContext, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Image, Button, Form, Alert } from 'react-bootstrap';
import { CartContext } from '../CartContext';
import './ProductDetail.css';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [productName, setProductName] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedMember, setSelectedMember] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [currentImage, setCurrentImage] = useState(0);
  const [error, setError] = useState('');
  const { addToCart } = useContext(CartContext);
  const productImageRef = useRef(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`https://shopapi.nogi46.me/api/products/${id}`);
        setProduct(response.data);
        setProductName(response.data.name);
        document.title = `${response.data.name}`;
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    };

    fetchProduct();
  }, [id]);

  if (!product) {
    return <div>Loading...</div>;
  }

  const handleAddToCart = () => {
    if ((product.sizes.length > 0 && !selectedSize) || (product.members.length > 0 && !selectedMember)) {
      setError('請選擇所有必需的選項');
      return;
    }
    
    const cartItem = {
      productId: product.productId,
      name: product.name,
      price: product.price,
      image: product.images[0],
      size: selectedSize,
      member: selectedMember,
      quantity: parseInt(quantity, 10),
    };
    addToCart(cartItem);
    setError('');
    animateAddToCart();
  };

  const animateAddToCart = () => {
    const cartIcon = document.querySelector('.cart-icon');
    const productImage = productImageRef.current;
    if (!cartIcon || !productImage) return;

    const cartIconRect = cartIcon.getBoundingClientRect();
    const productImageRect = productImage.getBoundingClientRect();

    const clone = productImage.cloneNode(true);
    clone.style.position = 'absolute';
    clone.style.top = `${productImageRect.top}px`;
    clone.style.left = `${productImageRect.left}px`;
    clone.style.width = `${productImageRect.width}px`;
    clone.style.height = `${productImageRect.height}px`;
    clone.style.transition = 'all 0.7s ease-in-out';
    document.body.appendChild(clone);

    setTimeout(() => {
      clone.style.top = `${cartIconRect.top}px`;
      clone.style.left = `${cartIconRect.left}px`;
      clone.style.width = '30px';
      clone.style.height = '30px';
      clone.style.opacity = '0.5';
    }, 100);

    setTimeout(() => {
      document.body.removeChild(clone);
    }, 800);
  };

  return (
    <Container>
      <Row>
        <Col md={6}>
          <Image
            src={product.images[currentImage]}
            alt={product.name}
            fluid
            ref={productImageRef}
            style={{ maxWidth: '80%', height: 'auto' }} // 調整圖片大小
          />
          {product.images.length > 1 && (
            <div className="image-thumbnails">
              {product.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`thumbnail-${index}`}
                  onClick={() => setCurrentImage(index)}
                  style={{
                    cursor: 'pointer',
                    border: currentImage === index ? '2px solid #000' : 'none',
                    width: '50px',
                    height: '50px',
                    objectFit: 'cover',
                    marginRight: '5px'
                  }}
                />
              ))}
            </div>
          )}
        </Col>
        <Col md={6}>
          <h1>{product.name}</h1>
          <p>{product.description.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}</p>
          <h3>價格: ${product.price}</h3>
          {error && <Alert variant="danger">{error}</Alert>}
          {product.status ? (
            <>
              {product.sizes.length > 0 && (
                <Form.Group controlId="sizeSelect">
                  <Form.Label>選擇大小</Form.Label>
                  <Form.Control as="select" value={selectedSize} onChange={(e) => setSelectedSize(e.target.value)}>
                    <option value="">請選擇</option>
                    {product.sizes.map((size, index) => (
                      <option key={index} value={size}>{size}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}
              {product.members.length > 0 && (
                <Form.Group controlId="memberSelect">
                  <Form.Label>選擇成員</Form.Label>
                  <Form.Control as="select" value={selectedMember} onChange={(e) => setSelectedMember(e.target.value)}>
                    <option value="">請選擇</option>
                    {product.members.map((member, index) => (
                      <option key={index} value={member}>{member}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}
              <Form.Group controlId="quantitySelect">
                <Form.Label>選擇數量</Form.Label>
                <Form.Control type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} min="1" />
              </Form.Group>
              <Button variant="primary" onClick={handleAddToCart} className="mt-3">加入購物車</Button>
            </>
          ) : (
            <p style={{ color: 'red' }}>缺貨</p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ProductDetail;
